import {
    useFormContext,
    Controller,
    FieldValues,
    FieldPath,
    ControllerProps,
} from "react-hook-form";
import { Box, FormHelperText, TextField, TextFieldProps } from "@mui/material";
import { isDefined } from "@convin/utils/helper/common.helper";

// ----------------------------------------------------------------------

export default function RHFTextField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
    name,
    onChange,
    value,
    charLimit,
    type,
    ...other
}: Exclude<TextFieldProps, "name"> & {
    charLimit?: number;
    name: ControllerProps<TFieldValues, TName>["name"];
}) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Box className="relative w-full" pb={1}>
                        <TextField
                            {...field}
                            fullWidth
                            error={!!error}
                            type={type}
                            {...other}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                onChange?.(e);
                            }}
                            value={value ?? field.value ?? ""}
                            onWheel={(e) =>
                                e.target instanceof HTMLElement &&
                                e.target.blur()
                            }
                        />
                        {isDefined(charLimit) || isDefined(error) ? (
                            <FormHelperText
                                component={"div"}
                                error={
                                    isDefined(charLimit) &&
                                    String(field.value).length > charLimit
                                }
                                className="absolute right-0 flex justify-between w-full"
                                sx={{ pl: 1.5 }}
                            >
                                <Box
                                    sx={{
                                        ...(error && { color: "danger" }),
                                    }}
                                >
                                    {error?.message}
                                </Box>

                                <Box>
                                    {isDefined(charLimit) &&
                                        `${
                                            typeof field.value === "string"
                                                ? field?.value?.length
                                                : 0
                                        }/${charLimit} Characters`}
                                </Box>
                            </FormHelperText>
                        ) : null}
                    </Box>
                );
            }}
        />
    );
}
